module.exports = __webpack_public_path__ + "img/wechat.3c19ba51.png";